import { BehaviorSubject } from "rxjs";
import { PriceRuleConditionBase } from "./price-rule-condition.base";

export class PriceRuleMembershipView extends PriceRuleConditionBase {
    public membershipLevelCode: string[];
    public preSelectedDataList$ = new BehaviorSubject<string[]>(null);
}